import { ButtonGroup } from 'ui/components'
import { Button } from 'ui/components/Buttons'

import { ActionsProps } from './Actions.types'

export const Actions = (props: ActionsProps) => {
  const { onAddUser } = props

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <ButtonGroup margin="small">
        {onAddUser && (
          <Button onClick={onAddUser} face="tertiary" data-qa="Add New">
            Add New
          </Button>
        )}
      </ButtonGroup>
    </div>
  )
}
